import { motion } from "framer-motion";
import styled from "styled-components";


export const SLoading = styled(motion.div)`
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.7);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    z-index: 200;
    

   div{
        border: 0.4rem solid #f3f3f3; /* Light grey */
        border-top: 0.4rem solid ${props => props.theme.colors.tertiary}; /* Blue */
        border-radius: 50%;
        width: 4rem;
        height: 4rem;
   }
`